import { createContext, useContext, useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, obj=auth
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch {
        setUser(false);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.access_token) localStorage.setItem("wms_token", data.access_token);
    setUser({ ...data.user });
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("wms_token");
    setUser(false);
  };

  const refreshUser = async () => {
    try { const { data } = await api.get("/auth/me"); setUser(data); } catch {}
  };

  const can = (perm) => {
    if (!user || !user.permissions) return false;
    if (user.permissions.includes("*")) return true;
    if (user.permissions.includes(perm)) return true;
    const mod = perm.split(".")[0];
    return user.permissions.includes(`${mod}.*`);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, refreshUser, can, formatApiError }}>
      {children}
    </AuthContext.Provider>
  );
}
